import React from 'react';
import './App.css';
import Route from './routes/Routes';


function App() {
  return (
    <Route />
  );
}

export default App;
